import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faChevronDown, faChevronUp, faCreditCard, } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Stack from "syf-component-library/ui/spacing/Stack";
import AccountDropDown from "./subcomponents";
import { useProfileGlobalState } from "../../../context/profileGlobalState";
import useCurrentAccount from "../../../hooks/useCurrentAccounts";
import getTranslation from "../../../strings/getTranslations";
var AccountSelect = function (_a) {
    var shouldDisableAccountSelect = _a.shouldDisableAccountSelect;
    var t = getTranslation().t;
    var _b = useProfileGlobalState(), selectedAccountId = _b.state.selectedAccountId, dispatch = _b.dispatch;
    var _c = useCurrentAccount(selectedAccountId), selectedAccountOption = _c.selectedAccountOption, accountsOptions = _c.accountsOptions;
    var handleAccountChange = function (newSelectedAccountId) {
        dispatch({
            selectedAccountId: newSelectedAccountId,
            shouldEditProfile: false,
            didEditMutationSucceeded: false,
        });
        sessionStorage.setItem("selectedAccountId", newSelectedAccountId);
    };
    return (_jsxs(_Fragment, { children: [_jsx(AccountDropDown, { id: "profile-mfe-select-account", name: "profileMfeSelectAccount", placeholder: t("labels.select"), options: accountsOptions, defaultOption: selectedAccountOption, onChange: function (_a) {
                    var value = _a.value;
                    handleAccountChange(value);
                }, isDisabled: shouldDisableAccountSelect, leftIcon: _jsx(FontAwesomeIcon, { icon: faCreditCard }), rightIconOpen: _jsx(FontAwesomeIcon, { icon: faChevronUp }), rightIconClosed: _jsx(FontAwesomeIcon, { icon: faChevronDown }) }), _jsx(Stack, { size: "xlarge" })] }));
};
export default AccountSelect;
